// Comprobante (remito) de transferencia entre depósitos — se abre en una ventana lista para imprimir / guardar como PDF.
const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
const fmt = (n) => Number(n || 0).toLocaleString("es-PY", { maximumFractionDigits: 3 });

export function imprimirRemitoDeposito(t) {
  const emp = t.empresa || {};
  const filas = (t.items || []).map((it, i) => `
    <tr>
      <td class="c">${i + 1}</td>
      <td>${esc(it.sku || "-")}</td>
      <td>${esc(it.nombre)}${it.variante_texto ? ` <span class="v">(${esc(it.variante_texto)})</span>` : ""}</td>
      <td class="r">${fmt(it.cantidad)} ${esc(it.unidad || "")}</td>
    </tr>`).join("");
  const fecha = t.fecha ? new Date(t.fecha).toLocaleString("es-PY") : "";
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>${esc(t.numero)}</title>
  <style>
    @page { size: A4; margin: 14mm; }
    * { box-sizing: border-box; }
    body { font-family: Arial, Helvetica, sans-serif; font-size: 12px; color: #111; margin: 0; }
    header { display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 2px solid #000; padding-bottom: 10px; margin-bottom: 12px; }
    .emp b { font-size: 16px; }
    .box { border: 2px solid #000; padding: 8px 16px; text-align: center; min-width: 220px; }
    .box .t { font-weight: bold; font-size: 13px; }
    .box .n { font-size: 15px; font-weight: bold; margin-top: 4px; }
    table { width: 100%; border-collapse: collapse; }
    .meta td, .meta th { border: 1px solid #999; padding: 6px 8px; text-align: left; }
    .meta th { background: #eee; width: 18%; }
    .det { margin-top: 14px; }
    .det th, .det td { border: 1px solid #999; padding: 6px 8px; }
    .det th { background: #eee; text-align: left; }
    .c { text-align: center; width: 5%; } .r { text-align: right; width: 16%; } .v { color: #555; }
    tfoot td { font-weight: bold; background: #f5f5f5; }
    .obs { margin-top: 14px; border: 1px solid #999; padding: 8px; min-height: 60px; }
    .firmas { display: flex; justify-content: space-between; margin-top: 90px; }
    .firmas div { width: 42%; border-top: 1px solid #000; text-align: center; padding-top: 5px; font-size: 11px; }
    .anulada { color: #b00; font-weight: bold; font-size: 16px; text-align: center; margin: 6px 0; }
  </style></head><body>
  <header>
    <div class="emp"><b>${esc(emp.nombre_fantasia || emp.razon_social || emp.nombre || "")}</b><br>
      ${emp.razon_social && emp.nombre_fantasia ? esc(emp.razon_social) + "<br>" : ""}
      ${emp.ruc ? "RUC: " + esc(emp.ruc) + "<br>" : ""}
      ${emp.direccion ? esc(emp.direccion) + "<br>" : ""}
      ${emp.telefono ? "Tel: " + esc(emp.telefono) : ""} ${emp.email ? " · " + esc(emp.email) : ""}</div>
    <div class="box"><div class="t">REMITO DE TRANSFERENCIA<br>ENTRE DEPÓSITOS</div><div class="n">N° ${esc(t.numero)}</div></div>
  </header>
  ${t.estado === "anulada" ? '<div class="anulada">COMPROBANTE ANULADO</div>' : ""}
  <table class="meta">
    <tr><th>Fecha</th><td>${esc(fecha)}</td><th>Emitido por</th><td>${esc(t.usuario_nombre || "")}</td></tr>
    <tr><th>Depósito origen</th><td>${esc(t.origen_codigo || "")} ${esc(t.origen_nombre)}</td><th>Depósito destino</th><td>${esc(t.destino_codigo || "")} ${esc(t.destino_nombre)}</td></tr>
  </table>
  <table class="det">
    <thead><tr><th class="c">#</th><th style="width:18%">SKU</th><th>Descripción</th><th class="r">Cantidad</th></tr></thead>
    <tbody>${filas}</tbody>
    <tfoot><tr><td colspan="3" style="text-align:right">Total de unidades</td><td class="r">${fmt(t.total_unidades)}</td></tr></tfoot>
  </table>
  <div class="obs"><b>Observaciones:</b> ${esc(t.notas || "")}</div>
  <div class="firmas"><div>Entregó (Depósito origen)<br>Firma · Aclaración · C.I.</div><div>Recibió (Depósito destino)<br>Firma · Aclaración · C.I.</div></div>
  <script>window.onload=function(){setTimeout(function(){window.print()},250)}</script>
  </body></html>`;
  const w = window.open("", "_blank");
  if (!w) return false;
  w.document.write(html);
  w.document.close();
  return true;
}
